import { Box, Chip, Collapse, FormHelperText, Stack } from "@mui/material";
import { useContext } from "react";
import { useUserInfo } from "../../utils/security";
import { isEmpty } from "lodash";
import { FilterContext } from "../../components/Filter";

export const FinancialAdvancedFilter = () => {
    const { userInfo } = useUserInfo();
    const { compact, filterVisible, setFilter, filter } = useContext(FilterContext);

    return (
        <Collapse in={filterVisible}>
            <Box sx={{ my: 2, px: compact ? 2 : 0 }}>
                <Box>
                    <FormHelperText component="div" sx={{ mb: 1 }}>
                        Typy transakcí
                    </FormHelperText>
                    <Stack direction="row" gap={1} flexWrap="wrap">
                        <Chip
                            label="Vše"
                            color={isEmpty(filter.transactionTypes) ? "primary" : "default"}
                            onClick={() => setFilter({ ...filter, transactionTypes: undefined })}
                        />
                        {userInfo?.transactionTypes?.map((transactionType) => {
                            const selected = filter.transactionTypes?.includes(transactionType.id);
                            return (
                                <Chip
                                    key={transactionType.id}
                                    label={transactionType.name}
                                    color={selected ? "primary" : "default"}
                                    onClick={() =>
                                        setFilter({
                                            ...filter,
                                            transactionTypes: selected
                                                ? filter.transactionTypes?.filter(
                                                      (id) => id !== transactionType.id
                                                  )
                                                : [
                                                      ...(filter.transactionTypes || []),
                                                      transactionType.id,
                                                  ],
                                        })
                                    }
                                />
                            );
                        })}
                    </Stack>
                </Box>
            </Box>
        </Collapse>
    );
};
